<div class="progress progress__back"></div>
<div class="progress progress__front" [style.width.%]="progress"></div>
